var isZero = function (letter) { return parseInt(letter, 10) === 0; };
/**
 * Checks if the fields is valid and gives human friendly
 * error messages for those fields which are invalid.
 * @param {object} values Collection of values to validate
 * @return {object} Collection of errors
 * */
// eslint-disable-next-line import/prefer-default-export
export function validateForm(values) {
    var errors = {};
    if (!values.price && !isZero(values.price)) {
        errors.price = 'Pris kan ikke være tom';
    }
    else if (values.price < 0 || values.price > 9999) {
        errors.price = "Pris m\u00E5 v\u00E6re mellom 0 og 9 999 kroner. Din pris er " + values.price + " kroner";
    }
    // Simply check for empty condition, and assume the radio buttons handles the rest
    if (!values.condition) {
        errors.condition = 'Du må spesifisere hvilken tilstand boken er i';
    }
    if (!values.salePoint) {
        errors.salePoint = 'Du må sette et utsalgssted';
    }
    return errors;
}
